import { render } from "./assign-work-approval.vue?vue&type=template&id=3a371eba&scoped=true"
import script from "./assign-work-approval.vue?vue&type=script&lang=js"
export * from "./assign-work-approval.vue?vue&type=script&lang=js"

import "./assign-work-approval.vue?vue&type=style&index=0&id=3a371eba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a371eba"]])

export default __exports__